<template>
	<v-row class="fill-height">
		<v-col>
			<v-sheet height="64">
				<v-toolbar flat color="white">
					<v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
						{{ $t('today') }}
					</v-btn>
					<v-btn fab text small color="grey darken-2" @click="$refs.calendar.prev()">
						<v-icon small>mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn fab text small color="grey darken-2" @click="$refs.calendar.next()">
						<v-icon small>mdi-chevron-right</v-icon>
					</v-btn>
					<v-toolbar-title class="ml-4">{{ momentDate }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-menu bottom left>
						<template v-slot:activator="{ on }">
							<v-btn icon v-on="on">
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>

						<v-list>
							<v-list-item @click="addHolidays">
								<v-list-item-title>{{ $t('add_holidays') }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-toolbar>
			</v-sheet>
			<v-sheet height="600">
				<v-calendar
					ref="calendar"
					color="primary"
					v-model="focus"
					:short-months="false"
					:weekdays="[1, 2, 3, 4, 5, 6, 0]"
					:events="events"
					:day-format="dayFormat"
					@click:date="openDialog($event.date, null)"
					@change="updateRange"
				>
					<!-- <template v-slot:day-label="date">
						<div v-if="start !== null && date.month === start.month">
							<v-btn :color="date.present ? 'blue' : ''" :text="!date.present" depressed small fab @click="openDialog(date.date, null)">
								{{ date.day }}
							</v-btn>
						</div>
					</template> -->

					<template v-slot:event="{ event }">
						<v-sheet no-gutters class="px-2" dark width="100%" height="100%" :color="event.color" @click="openDialog(null, event)">
							<div class="d-flex">
								<strong v-if="event.startTime" class="mr-2">{{ event.startTime }}</strong>
								<v-tooltip top :open-delay="300">
									<template v-slot:activator="{ on }">
										<span class="event-name" v-on="on">{{ event.name }}</span>
									</template>
									<span>{{ event.name }}</span>
								</v-tooltip>
								<v-spacer></v-spacer>
								<span v-if="event.endTime" class="ml-2">{{ event.endTime }}</span>
							</div>
						</v-sheet>
					</template>
				</v-calendar>
			</v-sheet>
		</v-col>

		<add-update v-if="dialog" :date="date" :event="event" @close="closeDialog(...arguments)" />

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" width="2"></v-progress-circular>
		</v-overlay>
	</v-row>
</template>

<script>
import AddUpdate from './components/AddUpdate'
import slotsMixin from '~/mixins/slotsMixin'
const emptyHack = [{ start: '1900-01-01' }]
export default {
	name: 'Absences',

	components: { AddUpdate },

	mixins: [slotsMixin],

	data() {
		return {
			focus: null,
			start: null,
			end: null,
			year: new Date().toISOString().substr(0, 4),
			month: new Date().toISOString().substr(0, 7),
			today: new Date().toISOString().substr(0, 10),
			events: emptyHack,
			dialog: false,
			date: null,
			event: null,
			loading: false
		}
	},

	computed: {
		momentDate() {
			return this.start ? this.$moment(this.start.date).format('MMMM YYYY') : ''
		}
	},

	methods: {
		dayFormat(date) {
			return date.day
		},
		setToday() {
			this.focus = this.today
		},
		async updateRange({ start, end }) {
			this.loading = true
			this.events = emptyHack

			this.start = start
			this.end = end
			this.year = start.date.substr(0, 4)
			this.month = start.date.substr(0, 7)
			let events = []

			let { data } = await this.$http.get(`absence/${this.month}`)

			data.forEach(event => {
				events.push(this.getEvent(event))
			})

			if (events.length > 0) {
				this.events = events
			}
			this.loading = false
		},
		getEvent(event) {
			return {
				start: event.begin_slot === this.min && event.end_slot === this.max ? event.begin_dt : event.start,
				end: event.begin_slot === this.min && event.end_slot === this.max ? event.end_dt : event.end,
				name: event.name,
				startTime: event.begin_slot === this.min && event.end_slot === this.max ? '' : event.start.substr(11, 5),
				endTime: event.begin_slot === this.min && event.end_slot === this.max ? '' : event.end.substr(11, 5),
				color: event.type === 'holiday' ? 'red' : 'green',
				id: event.id,
				absence: event
			}
		},
		openDialog(date, event) {
			this.date = date
			this.event = event
			this.dialog = true
		},
		closeDialog(action, data = null) {
			if (action === 'update') {
				this.remove(data.id)
				this.add(data)
			}
			if (action === 'add') {
				this.add(data)
			}
			if (action === 'remove') {
				this.remove(data)
			}

			this.dialog = false
		},
		add(data) {
			if (this.events === emptyHack) {
				this.events = [this.getEvent(data)]
			} else {
				this.events.push(this.getEvent(data))
			}
		},
		remove(id) {
			let events = this.events.filter(event => event.id !== id)
			this.events = events.length === 0 ? emptyHack : events
		},
		async addHolidays() {
			this.loading = true
			await this.$http.put(`holidays/${this.year}`)
			this.updateRange({ start: this.start, end: this.end })
		}
	}
}
</script>

<style lang="scss" scoped>
.event-name {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
